import editableData from "../data/siteEditable.json";

const collegeLogoMap = (editableData.collegeLogos || []).reduce((acc, entry) => {
  if (!entry || typeof entry.id !== "string") {
    return acc;
  }

  const logoUrl = typeof entry.logoUrl === "string" ? entry.logoUrl.trim() : "";
  acc[entry.id] = logoUrl;
  return acc;
}, {});

export const getCollegeLogoByKey = (logoKey) => {
  if (!logoKey) {
    return null;
  }

  const url = collegeLogoMap[logoKey];
  if (typeof url !== "string") {
    return null;
  }

  return url.trim() ? url : null;
};

export default collegeLogoMap;
